<template>
    <div>
        <button
            class="inquiry-form__sections notranslate"
            :disabled="!sections.length"
            @keydown.esc="closeSection"
            @click.prevent="onSectionClick"
        >
            {{ buttonLabel }}
        </button>
        <div v-show="displaySectionDrawer" class="inquiry-form__section-drawer">
            <strong class="inquiry-form__note" v-if="priceBlockNote">{{ priceBlockNote }}</strong>
            <table class="inquiry-form__table" v-if="sections.length" role="listbox">
                <tr class="inquiry-form__table-row inquiry-form__table-row--headers">
                    <th>Seating Section</th>
                    <th>Group Price</th>
                </tr>
                <tr 
                    v-for="(row, index) in sections"
                    class="inquiry-form__table-row"
                    :key="index" @keydown.up.prevent="setFocus(index - 1)"
                    @keydown.down.prevent="setFocus(index + 1)"
                    @keydown.esc="closeSection"
                    @keydown.enter.prevent="onRowClick(index)"
                    @keydown.space.prevent="onRowClick(index)"
                    @keydown.tab.prevent @click="onRowClick(index)"
                    @focusout="focusout"
                    @focusin="focusin"
                    :aria-selected="(index === value) ? 'true' : 'false'"
                    role="option"
                    tabindex="0">
                    <td><span>Seating Section:</span> {{ row.seatingSection }}</td>
                    <td><span>Group Price:</span> {{ row.groupPrice && '$'}}{{ row.groupPrice }}</td>
                </tr>
            </table>
        </div>

        <a href="#comp-alert-modal" id="comp-alert-trigger" class="js-modal-trigger"></a>
        <div class="modal modal--box" id="comp-alert-modal">
            <div class="modal__container" style="max-width:400px;background-color:#dedede">
                <div class="modal__content">
                    <p>You’re in luck! This production offers a complimentary ticket promotion for this performance. Once you have submitted your group ticket request, and if you qualify, our sales team will reach out to adjust accordingly.</p>
                    <p>For more information on the terms of this show’s policy, call 1-800-BROADWAY x2.</p>
                </div>
                <button class="modal__close" type="button" aria-label="Close modal">&#10005;</button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'InquiryFormSectionsSelectField',
    props: {
        value: [Number, String],
        sections: { type: Array, default: () => [] },
        priceBlockNote: { type: String, default: '' }
    },
    data() {
        return { displaySectionDrawer: false, hasFocus: false };
    },
    computed: {
        buttonLabel() {
            return this.sections.length && this.value !== ''
                ? this.sections[parseInt(this.value, 10)].seatingSection
                : 'Select';
        }
    },
    methods: {
        onRowClick(index) {
            if(this.sections[index].groupPrice && this.sections[index].groupPrice > 0){
                this.$emit('input', index);
                this.closeSection();
            } else {
                this.closeSection();
                jQuery('#comp-alert-trigger').click();
            }
        },
        onSectionClick(e) {
            if (
                !this.sections.length
                || e.target !== this.$el.querySelector('.inquiry-form__sections')
            ) {
                return;
            }

            this.displaySectionDrawer = !this.displaySectionDrawer;

            if (this.displaySectionDrawer) {
                const index = (this.value || 0) + 1;
                setTimeout(() => {
                    this.$el.querySelectorAll('.inquiry-form__table-row')[index].focus();
                }, 10);
            }
        },
        closeSection() {
            this.displaySectionDrawer = false;
            this.$el.querySelector('.inquiry-form__sections').focus();
        },
        focusout() {
            this.hasFocus = false;
            setTimeout(() => {
                if (!this.hasFocus) {
                    this.closeSection();
                }
            }, 10);
            this.$emit('blur')
        },
        focusin() {
            this.hasFocus = true;

            this.$emit('focus')
        },
        setFocus(index) {
            if (!(this.sections.length)) {
                return;
            }

            const rows = this.$el.querySelectorAll('.inquiry-form__table-row');
            const targetIndex = Math.min(Math.max(index, 0), this.sections.length);
            const row = rows[targetIndex + 1] || false;
            if (row) {
                row.focus();
            }
        },
    },
};
</script>
